<div class="round-button-container">
  <button mat-fab class="round-button origin-button"
    [disabled]="disabled"
    (click)="onChangeStatusRequested(); $event.stopPropagation();"
    [ngStyle]="{'background-color': currentColor, 'color': '#fff'}">
    <mat-icon>{{currentIcon}}</mat-icon>
  </button>
</div>

<ng-template #popupTemplate>
  <div class="popup-container" [@fadeInOut]>
    <div class="arrow" [ngStyle]="{
        'left': popupDirection === 'right' ? '-18px' : 'auto',
        'right': popupDirection === 'left' ? '-18px' : 'auto',
        'border-right-color': popupDirection === 'right' ? nextColor : 'transparent',
        'border-left-color': popupDirection === 'left' ? nextColor : 'transparent'}">
    </div>
    <div class="popup-content" [style.border-color]="nextColor">
      @if (description) {
        <div class="state-description m-0 p-0"><h4><b>{{description}}</b></h4></div>
      }
      <div class="state-transition">
        <div class="state current-state">
          <button mat-fab class="round-button mb-2" [ngStyle]="{'background-color': currentColor, 'color': '#fff'}">
            <mat-icon>{{currentIcon}}</mat-icon>
          </button>
          <p>{{currentDescription}}</p>
        </div>
        <div class="transition-arrow">
          <mat-icon>arrow_forward</mat-icon>
        </div>
        <div class="state next-state" (click)="switchState(); $event.stopPropagation()">
          <button mat-fab class="round-button mb-2 clickable-state" [ngStyle]="{'background-color': nextColor, 'color': '#fff'}">
            <mat-icon>{{nextIcon}}</mat-icon>
          </button>
          <p><b>{{nextDescription}}</b></p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
